<template lang="pug">
div
  TopBar(:influencer="influencer")
  Groups
</template>

<script>
import TopBar from "./TopBar";
import Groups from "./Groups/index";
import _ from "underscore";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { TopBar, Groups },
  props: ["url"],
  data() {
    return {
      influencer: null,
    };
  },
  computed: {
    ...mapGetters(["influencerShop"]),
  },
  mounted() {
    this.loadInfluencer();
  },
  methods: {
    ...mapActions(["setBizs", "setInfluencerShop"]),
    async loadInfluencer() {
      const params = {
        criteria: { code: { $regex: "^" + this.url + "$", $options: "i" } },
      };
      this.influencer = await this.$api.influencer.account.retrieve(params);
      this.loadShop();
    },
    async loadShop() {
      if (!this.influencer) return;
      const params = {
        criteria: { influencer: this.influencer._id },
      };
      const result = await this.$api.influencer.shop.retrieve(params);
      this.setInfluencerShop(result);
      this.loadBizs();
    },
    async loadBizs() {
      if (!this.influencerShop) return;
      const bizs = _.chain(this.influencerShop.groups)
        .pluck("bizs")
        .flatten()
        .compact()
        .value();
      const params = {
        criteria: { _id: { $in: bizs } },
        select: "name url logo",
      };
      try {
        const result = await this.$api.biz.list(params);
        this.setBizs(result);
      } catch (e) {
        //
      }
    },
  },
};
</script>
